'use client';

import React from 'react';
import { VideoModalProvider } from '@/contexts/VideoModalContext';
import { AuthProvider } from '@/contexts/AuthContext';
import VideoModal from '@/components/shared/VideoModal';

interface PageRendererWrapperProps {
  children: React.ReactNode;
}

export default function PageRendererWrapper({ children }: PageRendererWrapperProps) {
  return (
    <AuthProvider>
      <VideoModalProvider>
        {children}
        <VideoModal />
      </VideoModalProvider>
    </AuthProvider>
  );
}

